import script from "./UsernameInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsernameInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__